import { startCarousel } from "../../../services/assetsGenerationAPI";

export const handleStartGeneratingCarousel = async ({
  publicationId,
  token,
  setActiveTasks,
  setTaskStatus,
  setAlert,
  setupWebSocket,
  setRefreshTrigger = null,
}) => {
  try {
    const uniqueId = "pending";
    setActiveTasks((prev) => {
      const nextArr = [...(prev.carousel || [])];
      if (!nextArr.includes(uniqueId)) nextArr.push(uniqueId);
      return { ...prev, carousel: nextArr };
    });
    localStorage.setItem("activeTasks", "true");
    setTaskStatus(prev => ({
      ...prev,
      carousel: {
        ...(prev.carousel || {}),
        [uniqueId]: { progress: 0, status: "queued", publicationId: Number(publicationId) }
      }
    }));

    const result = await startCarousel(publicationId, token);

    if (result.error) {
      setAlert({ severity: "warning", message: result.error });
      setActiveTasks(prev => ({ ...prev, carousel: (prev.carousel || []).filter(id => id !== "pending") }));
    } else if (result.task_id) {
      setActiveTasks(prev => ({ ...prev, carousel: (prev.carousel || []).filter(id => id !== "pending") }));
      setupWebSocket(result.task_id, "carousel", publicationId, null, (message, severity) => {
        setAlert({ severity, message });
      });
      setAlert({
        severity: "success",
        message: "Carousel Generation Started",
      });
      if (setRefreshTrigger) {
        setRefreshTrigger(prev => prev + 1);
      }
    }
  } catch (error) {
    setActiveTasks(prev => ({ ...prev, carousel: (prev.carousel || []).filter(id => id !== "pending") }));
    setAlert({
      severity: "warning",
      message: "Failed to start Carousel generation. Please try again.",
    });
  }
};
